import {
  Component,
  ElementRef,
  forwardRef,
  HostBinding,
  Input,
  OnInit,
  ViewChild,
} from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { fileToBase64 } from 'src/app/shared/utils/file.helper';

@Component({
  selector: 'sx-input-file',
  templateUrl: './sx-input-file.component.html',
  styleUrls: ['./sx-input-file.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SxInputFileComponent),
      multi: true,
    },
  ],
})
export class SxInputFileComponent implements OnInit, ControlValueAccessor {
  @Input() accept: string = 'image/*, ';
  @Input() expand: string;
  @Input() base64 = false;

  @HostBinding('class.block') get block() {
    return this.expand === 'block';
  }

  @ViewChild('fileInput', { static: true }) fileInput: ElementRef;
  currentFile;
  fileLabel;

  imgPreviewDatUrl;

  constructor() {}

  ngOnInit() {}

  async onFileChanged(event: any) {
    const element: HTMLInputElement = event.srcElement
      ? event.srcElement
      : event.target;

    if (element.files && element.files.length > 0) {
      this.currentFile = element.files[0];
      this.fileLabel = this.currentFile.name;

      if (this.base64) {
        const base64String = await fileToBase64(this.currentFile);
        this._onChange({
          Name: this.currentFile.name,
          Type: this.currentFile.type,
          Data: base64String,
        });
      } else {
        this._onChange(this.currentFile);
      }
      element.value = '';
    }
  }

  onOpenImage(evt: MouseEvent) {
    evt.stopPropagation();
    evt.preventDefault();
    this.fileInput.nativeElement.click();
  }

  // ControlValueAccessor implementation
  private _onChange = (_: any) => {};
  private _onTouched = () => {};

  public writeValue(val: any) {
    this.currentFile = val;
    this.fileInput.nativeElement.value = null;
  }

  public registerOnChange(fn: (_: any) => void): void {
    this._onChange = fn;
  }
  public registerOnTouched(fn: () => void): void {
    this._onTouched = fn;
  }
}
